exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".am-checkbox[data-v-5e8c0ad8],.am-radio[data-v-5e8c0ad8]{display:inline-block;margin:0 10px 0 0}.coupon-div[data-v-5e8c0ad8]{font-family:Montserrat;font-weight:300;border:1px solid #dfdfe0;padding:30px 50px 30px 30px}.coupon-div .panel.panel-default[data-v-5e8c0ad8]{margin-top:20px;margin-bottom:0;background-color:#e0e0e0;border:0;border-radius:0;padding:10px;font-size:13px}[data-v-5e8c0ad8]::-webkit-input-placeholder{text-transform:lowercase}.coupon-remove[data-v-5e8c0ad8]{color:#ed1763;text-decoration:none;font-size:25px;display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5e8c0ad8","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/store/components/Freight.vue
// module id = mxPd
// module chunks = 102